import React from "react";
import { Button } from "reactstrap";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import useTutorialState from "../TutorialHooks";
import { updateTutorialState } from "../TutorialActions";
import { Header } from "../Components";
import { updateVideoDetailBreadcrumb } from "../../../Pages/Video/VideoActions";

import "./FirstVideoStyles.scss";
import "../TutorialModalstyles.scss";

const FirstVideoStep2 = ({}) => {
  const { activeStep, showStep } = useTutorialState("first-video");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const skipTour = () => {
    dispatch(
      updateTutorialState({
        isTutorial: false,
        activeTutorial: "",
        activeStep: 1,
        totalSteps: 0,
      })
    );
    localStorage.removeItem("toturialScreen");
  };

  // const startTour = () => {
  //   localStorage.removeItem("toturialScreen");
  //   navigate("/videos/639b80fb7e0802b89600002e"); //@TODO
  //   const videosPageBreadcrumb = [
  //     {
  //       name: "Videos",
  //       type: "link",
  //       link: "/videos",
  //       page: "videos",
  //     },
  //     {
  //       name: "Videos",
  //       tab: "My Videos",
  //       type: "tab",
  //       link: "/videos",
  //       page: "videos",
  //     },
  //   ];
  //   dispatch(updateVideoDetailBreadcrumb(videosPageBreadcrumb));
  //   dispatch(
  //     updateTutorialState({
  //       isTutorial: true,
  //       activeTutorial: "video-detail",
  //       activeStep: 1,
  //       totalSteps: 5,
  //     })
  //   );
  // };

  if (showStep && activeStep === 2) {
    return (
      <div className="tutorial-modal">
        <div className="FirstVideoStyles">
          <div className="FirstVideoStep2">
            <Header
              showProgress={false}
              // successMessage="Congratulations on adding your first video!"
            />

            <div
              className="description"
              style={{ width: "297px", lineHeight: "36px" }}
            >
              Video analysis takes about 10 minutes. In the meantime,{" "}
              <b>upload more videos</b> to{" "}
              <b>create your first video carousel</b> to boost sales and
              conversion. A minimum of{" "}
              <span className="pink-highlight"> 5 videos is required</span>.
            </div>

            <div className="footer-sec">
              <Button
                color="outline-primary"
                className="step-btn"
                style={{ width: "153px", fontSize: "12px" }}
                onClick={() => {
                  dispatch(updateTutorialState({ openVideoModal: true }));
                  skipTour();
                }}
              >
                Upload More Videos
              </Button>
              {/* <div className="skip-btn">
                <span onClick={() => skipTour()}>Skip</span>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default FirstVideoStep2;
